/**
 * Marketing API Client
 *
 * Pure data access layer for marketing operations (email capture, etc.)
 *
 * @file marketing.api.ts
 * @version 1.0.0
 */

import { getApiEndpoint } from '@/shared/config/environment';
import { apiFetchJson } from '@/shared/lib/api/api-fetch-wrapper';

// =============================================================================
// TYPES
// =============================================================================

interface CaptureEmailRequest {
  email: string;
  source: 'exit_intent' | 'idle_timeout' | 'manual';
}

interface CaptureEmailResponse {
  success: boolean;
  discount_code?: string;
  message: string;
}

// =============================================================================
// API CLIENT
// =============================================================================

class MarketingApiClient {
  /**
   * Capture email address for marketing purposes
   * Returns discount code TANGI10 for 10% off first order
   */
  async captureEmail(request: CaptureEmailRequest): Promise<CaptureEmailResponse> {
    const url = getApiEndpoint('marketing/capture-email');

    return apiFetchJson<CaptureEmailResponse>(url, {
      method: 'POST',
      body: JSON.stringify(request),
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}

export const marketingApiClient = new MarketingApiClient();
